import { takeLatest, call, put, all, select, race } from 'redux-saga/effects';
import { push } from 'react-router-redux';
import Api from '../../utils/Api';
import SsoActionTypes from './sso.types';
import UtilsTypes from '../utilities/utils.types';
import Loader from '../../utils/Loader';
import {
	getReturnPath,
	getReturnSearch,
	getSso,
	getToken,
} from './sso.selectors';
import { clearLocalStorage } from '../../utils/commonFunctions';
import { CHANGE_LOGIN_ID } from '../userAuthentication/userAuth.actionTypes';
function* setError(msg) {
	if (msg === 'Token is Invalid' || msg === 'Token is missing') {
		clearLocalStorage();
		yield put(push('/'));
	} else {
		yield put({ type: UtilsTypes.SET_ERROR_MSG, payload: msg });
	}
	Loader.hide();
}

function delay(ms) {
	return new Promise((resolve) => setTimeout(() => resolve(true), ms));
}

function* validateUser() {
	const returnPath = yield select(getReturnPath);
	const returnSearch = yield select(getReturnSearch);
	const sso = yield select(getSso);
	const token = yield select(getToken);

	try {
		const res = yield call(Api, {
			url: 'validateuser',
			method: 'GET',
			headers: { 'access-token': !!token ? token : localStorage.getItem('token') },
		});
		if (!res.status) {
			yield call(setError, res);
		} else {
			if (res.code === 200) {
				Loader.hide();
				localStorage.setItem('token', res.data.token);
				localStorage.setItem('username', res.data.user_name);
				localStorage.setItem('login_id', res.data.login_id);
				localStorage.setItem('user_pic', res.data.user_pic);
				localStorage.setItem('login_user_id', res.data.user_id);
				localStorage.setItem('sso', sso);
				localStorage.setItem('email', res.data.email);
				localStorage.setItem('phone', res.data.phone);

				yield put({ type: SsoActionTypes.VALIDATE_USER.SUCCESS });
				yield put({ type: CHANGE_LOGIN_ID, payload: res.data.login_id });
				// eslint-disable-next-line no-unused-vars
				const timeout = yield race({
					timeout: call(delay, 2000),
				});

				yield put(push(`${returnPath}${returnSearch}`));
			} else {
				yield call(setError, res.message);
			}
		}
	} catch (err) {
		console.log('sso', err);
	}
}

function* validateUserStart() {
	yield takeLatest(SsoActionTypes.VALIDATE_USER.PENDING, validateUser);
}

export function* allSsoSagas() {
	yield all([call(validateUserStart)]);
}
